import { API_ROOT } from '../../config/config'
import { doDelete, doGet, doDownload, doPostFiles } from './utils'

// const API_ROOT = 'http://localhost:9014/api'

export const getSubProjectIncomeRecord = (subProjectCode, periodNo, id) => {
  const url = `${API_ROOT}/v1/accounting/subproject/income/${subProjectCode}/${periodNo}?id=${
    id || ''
  }`
  return doGet(url)
}

export const saveSubProjectIncomeRecord = (request) => {
  const url = `${API_ROOT}/v1/accounting/subproject/income/save`
  return doPostFiles(url, request)
}
export const deleteSubProjectIncomeRecord = (id) => {
  const url = `${API_ROOT}/v1/accounting/subproject/income/${id}`
  return doDelete(url)
}
export const downloadSubProjectIncomeRecordAttacthment = (fileId) => {
  const url = `${API_ROOT}/v1/accounting/subproject/income/attachments/download/${fileId}`
  return doDownload(url)
}

export const downloadSubProjectIncomeRecordVoucherFile = (accountingIncomeId) => {
  const url = `${API_ROOT}/files/${accountingIncomeId}/reciept/voucher/form`
  return doDownload(url)
}